var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("雪花算法ID生成")]),_c('div',{staticStyle:{"max-width":"600px","margin-top":"20px"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.getIds}},[_vm._v("生成ID")]),_vm._m(0),_c('el-input',{attrs:{"type":"textarea","rows":10,"value":_vm.ids.join('\n'),"readonly":""}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticStyle:{"margin-top":"20px"}},[_c('strong',[_vm._v("生成的ID列表：")])])
}]

export { render, staticRenderFns }